import React, {useEffect, useState} from "react";
import {connect, useDispatch, useSelector} from "react-redux";
import withRouter from "../../components/Common/withRouter";
import {Button, Card, CardBody, Col, Container, FormGroup, Label, Row,} from "reactstrap";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import {createAdmin, getAdmins, getCompanies, getUsers} from "../../store/actions";

import ObjectColumns from "./ObjectColumns";
import {notification} from "antd";
import Preloader from "../../components/Preloader/Preloader";
import Error from "../../components/Error/Error";
import Nulled from "../../components/Null/Nulled";
import PaginationComponent from "../../components/PaginationComponent";
import {apiFetch} from "../../components/CommonForBoth/TopbarDropdown/NotificationDropdown";

const Index = props => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [array, setArray] = useState([]);
    const [arrayCount, setArrayCount] = useState(0);

    const [skip, setSkip] = useState(0);
    const [limit, setLimit] = useState(10);


    useEffect(() => {
        const controller = new AbortController();

        const load = async () => {
            setIsLoading(true);
            setError("");

            try {
                // подстрой URL под свой backend:
                // 1) query params: ?skip=0&limit=10
                // 2) или body: POST {skip,limit} /api2/notification/all/${skip}/${limit}
                const res = await apiFetch(
                    `/api2/notification/all/${skip}/${limit}`,
                    { method: "GET", signal: controller.signal }
                );

                // ожидаемый формат, подстрой под свой ответ:
                // { ok:true, result:{ items:[], total:123 } }
                const items = res?.result || [];
                const total = res?.resultCount || 0;

                setArray(items);
                setArrayCount(total);
            } catch (e) {
                if (e.name !== "AbortError") {
                    setError(e.message || "Failed to load companies");
                }
            } finally {
                setIsLoading(false);
            }
        };

        load();
        return () => controller.abort();
    }, [skip, limit]);


    const handlePagination = (newSkip) => {
        setSkip(newSkip);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title={process.env.REACT_APP_PROJECT_NAME}
                                 breadcrumbItem="შეტყობინებები"/>
                    {isLoading ? (
                        <Preloader/>
                    ) : error ? (
                        <Error/>
                    ) : (
                        <Row>
                            {
                                array.length > 0
                                    ?
                                    <>
                                        <Col lg={12} style={{overflowX:'auto'}}>
                                            <ObjectColumns
                                                array={array}
                                            />
                                        </Col>
                                        <PaginationComponent
                                            skip={skip}
                                            limit={limit}
                                            totalItems={arrayCount}
                                            handlePageClick={handlePagination}
                                        />

                                    </>
                                    : <Nulled/>
                            }
                        </Row>
                    )}


                </div>
            </div>
        </React.Fragment>

    )
}

export default withRouter(Index);
